import env from '../common/env.js';
import wxBridge from '../jsbridge/jsbridge_base.js';

// https://iwiki.woa.com/display/wechatSearch/openFinderView
wxBridge.openFinderView =wxBridge.openFinderView || function(param, callback) {
    if( param.action === 'openFinderProfile') { // 打开视频号Profile页
        param.commentScene = 9; // 9:游戏中心
    }else if( param.action === 'openFinderFeed' ) { // 打开视频号Feed详情页
        param.shareScene = 16; // 16:游戏中心
        param.requestScene = 18; // 相似feed - 18:出游戏中心内容
    }else if( param.action === 'autoOpenFinderLive') {
        param.commentScene = 9; // 9:游戏中心
    } else if (param.action === 'openFinderMultiMoreLive') { // 跳转直播合集页
        param.requestScene = 1; // 1：游戏
        param.useDarkStyle = env.isDarkMode ? true: false;
        param.entryScene = 9;
    }
    wxBridge.invoke('openFinderView', {
        extInfo: JSON.stringify(param)
    }, callback);
};

export default wxBridge;

export const {
    openFinderView
} = wxBridge;
